import React from 'react'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import PercentIcon from 'components/icons/PercentIcon'
import { MarksFlex } from 'modules/Students/Partials/AddNewStudentDrawer/Style/style'
import { validateNumber } from 'utils/decimalValidation'
import { Alert } from 'antd'

const MarksDetails = ({ studentBatch, marksType, degreeOptions }) => {
  return (
    <>
      <Label marginTop={'2px'} required={true}>
        Mark
      </Label>
      <Input
        width="50%"
        placeholder="Eg: 80.50"
        type="text"
        name={'averageMarks'}
        rules={[
          {
            required: false,
            message: 'Please enter the Mark',
          },
          {
         validator: (_, value) => {
        if (value === undefined || value === '') {
          return Promise.resolve(); // let 'required' handle empty case
        }

        const isValid = validateNumber(value);
        const numValue = parseFloat(value);

        if (!isValid) {
          return Promise.reject(new Error('Not valid'));
        }

        // if (numValue < 30) {
        //   return Promise.reject(new Error('Percentage must be greater than 30'));
        // }

        return Promise.resolve();
      },
    },
        ]}
        suffix={<PercentIcon />}
      />

      <Alert
        style={{ width: '100%' }}
        message=" Note: Please convert the CGPA/GPA into Percentage"
        type="info"
      />
      <MarksFlex spaceBetween>
        <Label marginTop={'10px'} required={true}>
          No. of Arrears / Backlogs
        </Label>
        <Input
          width="50%"
          placeholder="0"
          type="text"
          name={'noOfArrears'}
          rules={[
            {
              required: false,
            },
            {
              validator: (_, value) => {
                if (value === undefined || value === '') {
                  return Promise.resolve()
                }
                if (value >= 0 && value < 100) {
                  return Promise.resolve()
                } else {
                  return Promise.reject(new Error('Not Valid!'))
                }
              },
            },
          ]}
        />
      </MarksFlex>
    </>
  )
}

export default MarksDetails
